import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'fury-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent implements OnInit {
  protected readonly environment = environment;

  public year: string = '2025';

  constructor() {
  }

  ngOnInit(): void {
    this.year = moment().format('Y');
  }
}

